var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyCombo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4244_14014)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.566 30.7602C21.4383 31.3985 18.1893 31.9666 14.2637 31.9985C10.3381 32.0305 6.91676 31.5262 6.76356 30.8496C6.73165 30.69 5.68481 27.9325 5.68481 27.9325H22.5043C22.5043 27.9325 21.5979 30.6006 21.566 30.7602Z",
    fill: "url(#paint0_linear_4244_14014)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2917 27.9198C17.7044 29.2411 17.6534 30.5943 14.8767 31.9922C18.5215 31.9092 21.4449 31.3539 21.5662 30.7603C21.5981 30.6007 22.5045 27.9134 22.5045 27.9134L18.2917 27.9198Z",
    fill: "#772781"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5234 27.8686C22.3638 28.641 18.6935 29.2602 14.2254 29.2793C9.75718 29.2985 5.87624 28.6985 5.68475 27.9006C5.49325 27.1027 9.31675 26.375 14.1871 26.375C19.0574 26.375 22.683 27.0708 22.5234 27.8686Z",
    fill: "url(#paint1_linear_4244_14014)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2361 27.441C21.2914 26.8027 18.0998 26.375 14.1806 26.375C11.8916 26.3355 9.60477 26.5345 7.35703 26.9687C7.14 27.5559 6.77617 27.6963 7.41448 27.9325C8.05279 28.1687 17.5317 29.4134 22.2361 27.441Z",
    fill: "#772781"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51024 27.4921C7.38258 27.4921 6.67406 27.7602 6.87193 27.8815C7.06981 28.0028 8.78687 28.7751 13.4338 28.7751C18.0807 28.7751 21.0935 27.99 21.1956 27.8049C21.2978 27.6198 11.0401 27.0709 7.51024 27.4921Z",
    fill: "#772781"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4363 11.9428C21.9683 10.2577 22.3513 3.88733 22.3513 3.88733L5.39771 4.12351C5.39771 4.12351 5.73601 10.0151 7.07647 11.8598C8.41692 13.7046 9.84674 14.1769 10.6638 14.7705C11.4808 15.3642 11.417 16.9089 10.7851 17.8089C10.3191 18.4472 7.09562 19.6217 6.43816 21.6388C5.7807 23.6558 7.15306 27.7985 7.15306 27.7985C10.9063 28.8006 16.4724 28.7113 20.7555 27.7985C20.7555 27.7985 21.4704 23.8537 21.2342 21.6388C21.0746 20.2153 17.149 18.5749 16.0767 17.943C15.0043 17.311 14.9979 15.5238 16.0001 14.9748C17.0022 14.4259 19.1597 13.3663 20.4363 11.9428Z",
    fill: "url(#paint2_linear_4244_14014)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M21.3236 5.2916C21.3236 5.2916 20.481 10.9151 20.6342 10.9151C21.0606 10.3818 21.3577 9.75692 21.5023 9.08955C21.8132 7.73203 22.0265 6.35401 22.1406 4.96605C22.1853 4.42349 21.3236 5.2916 21.3236 5.2916Z",
    fill: "url(#paint3_linear_4244_14014)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M5.64673 4.90219C5.64673 4.90219 6.03609 9.26824 6.57866 10.4044C7.12122 11.5406 7.71486 11.5406 7.71486 11.5406C7.22484 10.4438 6.87319 9.2902 6.66802 8.10651C6.52187 6.9958 6.48127 5.87374 6.54675 4.75537L5.64673 4.90219Z",
    fill: "url(#paint4_linear_4244_14014)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01038 13.6663C9.67738 14.0471 10.3172 14.4737 10.9253 14.9429C11.8509 15.7791 11.3274 17.1259 11.0211 17.694C10.8462 17.957 10.6123 18.1756 10.3381 18.3323C9.97422 18.5685 11.5572 18.1855 12.0551 17.1642C12.253 16.6599 12.3615 15.4791 12.0551 15.1727C11.0881 14.579 10.069 14.0748 9.01038 13.6663Z",
    fill: "#772781"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6063 13.9088C16.4977 13.7556 14.9211 14.8024 14.6211 15.2237C14.407 15.5253 14.274 15.8768 14.2349 16.2445C14.1958 16.6123 14.2518 16.9839 14.3977 17.3238C14.8062 18.0004 16.1275 18.2621 16.4275 18.3004C16.7275 18.3387 15.6743 17.994 15.3424 17.3684C15.1192 17.0168 15.0293 16.5969 15.0891 16.1847C15.1488 15.7726 15.3541 15.3954 15.6679 15.1216C16.3956 14.5535 16.702 14.0556 16.6063 13.9088Z",
    fill: "#772781"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M6.73792 5.08096C6.73792 5.20224 6.53367 9.35127 7.96987 11.4641C9.40607 13.5769 12.2657 14.5024 12.3487 15.5812C12.4317 16.6599 12.3168 17.3238 11.7104 17.9557C11.104 18.5876 8.0337 20.2026 7.24219 21.3579C6.45069 22.5133 7.79752 26.6367 8.19966 27.2176C8.83797 28.1623 18.7127 28.3027 19.568 27.5368C20.4233 26.7708 20.768 22.4303 20.2893 21.4154C19.8106 20.4004 15.3871 18.6515 14.7424 18.0897C13.7913 17.2599 13.5551 15.8493 15.1126 14.6493C15.8849 14.0556 19.1276 12.179 19.8808 11.1449C20.634 10.1109 21.2021 4.92139 21.2021 4.92139L6.73792 5.08096Z",
    fill: "url(#paint5_linear_4244_14014)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M7.67014 25.7941C7.80665 26.2962 7.99712 26.782 8.23824 27.2431C8.87655 28.1878 18.7512 28.3282 19.6066 27.5623C20.0254 26.9577 20.2764 26.2529 20.3342 25.5197C20.4619 24.7537 16.5044 20.4706 13.2618 20.5408C10.0191 20.611 7.44674 25.0282 7.67014 25.7941Z",
    fill: "url(#paint6_linear_4244_14014)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6341 8.48958C20.4746 7.94701 16.6575 6.88742 13.1148 7.21296C10.1914 7.5002 7.18492 9.12789 7.20407 9.35768C7.45071 10.5838 8.11095 11.6879 9.07432 12.4854C10.3509 13.4812 11.5063 14.1003 12.2659 15.0004C13.0255 15.9004 13.0957 21.6899 13.1021 21.9388C13.1978 24.824 13.517 22.941 13.4595 21.7601C13.4021 20.5792 13.3127 16.3919 14.634 15.0067C15.9553 13.6216 18.9809 12.0833 19.6703 11.2216C20.2027 10.3997 20.5329 9.46354 20.6341 8.48958Z",
    fill: "url(#paint7_linear_4244_14014)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20423 9.38321C9.45109 13.2131 17.2321 12.5748 20.6088 8.48958C20.4492 7.94701 16.6321 6.88742 13.0895 7.21296C10.2234 7.52573 7.19785 9.14704 7.20423 9.38321Z",
    fill: "url(#paint8_linear_4244_14014)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1595 6.06397C22.3127 4.78735 22.3702 3.88733 22.3702 3.88733L5.41663 4.12351C5.41663 4.12351 5.47407 5.04905 5.62088 6.27461C10.5486 8.99382 17.6658 9.15978 22.1595 6.06397Z",
    fill: "#9A376D"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9896 4.69159C22.7343 5.52778 18.847 6.28098 13.7341 6.28098C8.62125 6.28098 4.47861 5.57246 4.47861 4.69159C4.47861 4.45541 3.99988 1.58301 3.99988 1.58301H23.4811C23.3821 2.62841 23.2179 3.66661 22.9896 4.69159Z",
    fill: "url(#paint9_linear_4244_14014)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38257 2.05537C4.38257 2.05537 5.41663 3.72775 9.04862 4.1235C12.6806 4.51925 18.3616 3.12773 18.3807 3.00645C18.4446 2.55964 4.64428 1.41705 4.38257 2.05537Z",
    fill: "#78617A"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M4.39526 2.02979C4.39526 2.02979 5.67189 3.01918 9.50176 3.25536C12.4251 3.36926 15.3528 3.29036 18.2658 3.01918C18.2658 3.01918 11.2444 1.74256 8.99112 1.58298C7.44585 1.51778 5.89903 1.66817 4.39526 2.02979Z",
    fill: "url(#paint10_linear_4244_14014)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8978 1.58301C18.5653 3.37405 17.6443 5.00277 16.2808 6.21077C20.1106 6.0129 22.7915 5.38735 23.0022 4.69159C23.2283 3.66648 23.3903 2.62827 23.4873 1.58301H18.8978Z",
    fill: "#772781"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4875 1.58302C23.4875 2.18303 21.4193 2.71283 18.381 2.98092C17.0086 3.1022 9.04885 1.64046 4.40194 2.02983C4.14662 1.8894 4.01257 1.73621 4.01257 1.58302C4.01257 0.708528 8.37224 0 13.7532 0C19.1342 0 23.4875 0.708528 23.4875 1.58302Z",
    fill: "url(#paint11_linear_4244_14014)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44864 27.2559C8.44864 27.2559 9.45079 27.7601 13.3573 27.8942C17.2637 28.0282 19.1021 27.6453 19.4595 27.4346C19.817 27.224 16.702 24.492 13.3253 24.4728C10.4593 24.4792 8.30821 26.375 8.44864 27.2559Z",
    fill: "url(#paint12_linear_4244_14014)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9509 25.4367C11.0593 29.19 9.29118 26.5601 9.03585 26.1325C8.86613 26.2694 8.72642 26.4398 8.62539 26.6331C8.52436 26.8264 8.46418 27.0384 8.44861 27.2559C8.44861 27.2559 9.45076 27.7602 13.3572 27.8942C17.2637 28.0282 19.102 27.6453 19.4595 27.4346C19.6701 27.3261 18.5914 26.2537 16.9509 25.4367Z",
    fill: "#E09590"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M17.0977 18.4791C16.6764 18.2685 16.3253 18.0898 16.0955 17.9557C15.0232 17.3174 15.0168 15.5365 16.0189 14.9876C17.5479 14.2395 18.9675 13.286 20.2382 12.1535C18.1412 12.9937 15.896 13.4014 13.6374 13.352C11.3789 13.3027 9.15363 12.7973 7.09534 11.8662C8.44856 13.7365 9.86561 14.1769 10.6826 14.7705C11.4997 15.3642 11.4359 16.9089 10.8039 17.8089C10.5316 18.064 10.2242 18.279 9.89114 18.4472C11.0226 17.9287 12.2534 17.6629 13.4979 17.6685C14.7425 17.674 15.9709 17.9506 17.0977 18.4791Z",
    fill: "url(#paint13_linear_4244_14014)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39343 24.6516C6.56451 25.7223 6.81629 26.7785 7.14664 27.8113C10.8999 28.8134 16.466 28.724 20.7491 27.8113C20.7491 27.8113 21.0108 26.3687 21.164 24.7346C20.9852 25.6882 20.5429 26.5726 19.8873 27.2878C18.6107 28.5006 16.6128 28.4879 12.5148 28.2262C6.63599 27.8751 7.74027 27.9006 6.39343 24.6516Z",
    fill: "#772781"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71045 27.7538C5.71045 27.7538 6.84665 28.6219 10.7659 28.9793C14.6851 29.3368 21.2597 28.6219 21.2597 28.6219C21.2597 28.6219 14.2894 29.6368 10.4084 29.2219C6.52749 28.807 5.71045 27.7538 5.71045 27.7538Z",
    fill: "#FFFFB3"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9637 19.1175C10.485 19.3089 7.32532 21.3515 7.91895 21.9196C8.51258 22.4877 10.2679 21.3515 10.6126 20.726C10.9573 20.1005 11.1105 19.06 10.9637 19.1175Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88721 20.6877C7.92551 20.7323 10.6192 18.8366 10.6064 18.811C10.5937 18.7855 9.55959 19.4493 8.95958 19.8004C8.54907 20.0254 8.18513 20.3265 7.88721 20.6877Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72975 7.71715C6.75737 7.95333 8.19357 11.1832 8.96592 11.247C9.73828 11.3109 10.7021 7.4746 8.72975 7.71715Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8,
    d: "M14.7678 14.9939C14.7678 14.9939 15.6295 14.3556 16.6125 13.7173C17.4487 13.1492 18.3998 12.5555 18.719 12.313C19.402 11.7896 19.5871 11.7896 20.0658 10.9917C20.5445 10.1938 21.1254 6.41498 21.1254 6.41498C21.1254 6.41498 20.6786 9.60654 19.7977 10.947C19.3445 11.6491 17.8828 12.7087 16.7019 13.5641C15.521 14.4194 14.7678 14.9939 14.7678 14.9939Z",
    fill: "url(#paint14_linear_4244_14014)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8,
    d: "M6.73828 6.42139C6.73828 6.42139 6.8468 9.22996 7.8298 10.8896C8.68399 12.2341 9.813 13.3827 11.1426 14.2599C9.80621 13.4825 8.65075 12.4293 7.7532 11.1704C6.92978 9.92572 6.73828 6.42139 6.73828 6.42139Z",
    fill: "url(#paint15_linear_4244_14014)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M7.29999 21.326C8.37874 20.726 11.4299 21.0834 12.3299 22.3409C13.2299 23.5984 15.0172 28.2006 14.481 28.2006C13.9448 28.2006 7.54255 28.2006 7.29999 27.5623C7.05743 26.924 6.22763 21.9643 7.29999 21.326Z",
    fill: "url(#paint16_linear_4244_14014)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M6.18909 6.42773C6.18909 6.42773 6.57846 10.6151 8.48701 12.3193C10.3956 14.0236 13.0382 13.8768 14.4425 13.5194C15.8467 13.1619 16.2361 8.13203 15.668 7.86394C15.0999 7.59584 7.03166 6.45965 6.18909 6.42773Z",
    fill: "url(#paint17_linear_4244_14014)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6128 21.3643C19.1468 21.2622 19.1085 22.1047 19.4085 22.1367C19.7085 22.1686 20.4362 21.5303 19.6128 21.3643Z",
    fill: "#FFFDFF"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2129 18.2238C11.5129 17.9876 12.2597 17.3493 11.8512 17.2472C11.4427 17.1451 10.9065 18.46 11.2129 18.2238Z",
    fill: "#FFFDFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11047 23.0111C7.47216 23.1962 8.24452 24.1282 8.61474 24.0579C8.98496 23.9877 8.94666 22.7749 8.11047 23.0111Z",
    fill: "#FFFDFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4982 1.05318C17.5066 0.817007 9.01071 1.09787 15.113 1.77448C21.2152 2.45109 22.128 1.37234 19.4982 1.05318Z",
    fill: "#4F2A6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9725 1.75535C9.13829 1.11704 17.5257 0.817039 19.4981 1.0596C19.9168 1.08776 20.3273 1.18931 20.7109 1.3596C18.5981 1.26386 14.3852 1.41705 14.9725 1.75535Z",
    fill: "#4F2A6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94679 0.69574C7.86804 0.69574 3.64242 1.17448 8.07231 1.29575C12.5022 1.41703 10.2234 0.69574 8.94679 0.69574Z",
    fill: "#4F2A6F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4722 0.944673H10.0765C9.13465 0.955557 8.19695 1.07116 7.28068 1.28936C4.17848 1.13617 7.91899 0.71488 8.92752 0.71488C9.45108 0.712921 9.97191 0.790401 10.4722 0.944673Z",
    fill: "#4F2A6F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4244_14014",
    x: -0.00012207,
    y: 0,
    width: 27.4875,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4244_14014"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4244_14014",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4244_14014",
    x1: 21.8852,
    y1: 37.2646,
    x2: 11.2637,
    y2: 25.7558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F3A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4244_14014",
    x1: 13.4338,
    y1: 36.7986,
    x2: 14.0339,
    y2: 28.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#776783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4244_14014",
    x1: 13.8936,
    y1: 3.05114,
    x2: 13.8936,
    y2: 33.0518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9082A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#9386AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9D90B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ADA3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C4BCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E1DDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9082A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4244_14014",
    x1: 21.6428,
    y1: 6.1597,
    x2: 20.1746,
    y2: 12.9769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#772781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#7C3086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8B4894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A270AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3A6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4244_14014",
    x1: 6.85314,
    y1: 3.67662,
    x2: 6.6425,
    y2: 9.20441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#772781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#7C3086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8B4894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A270AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3A6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4244_14014",
    x1: 12.8147,
    y1: -11.0683,
    x2: 15.1317,
    y2: 31.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9082A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9386AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9D90B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ADA3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C4BCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E1DDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4244_14014",
    x1: 13.4532,
    y1: 15.3322,
    x2: 14.2128,
    y2: 29.3559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9082A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9386AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#9D90B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ADA3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C4BCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#E1DDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4244_14014",
    x1: 14.1617,
    y1: 5.10653,
    x2: 13.0893,
    y2: 22.4367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4244_14014",
    x1: 7.20423,
    y1: 9.54917,
    x2: 20.6343,
    y2: 9.54917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4244_14014",
    x1: 21.6683,
    y1: 14.8726,
    x2: 12.0937,
    y2: 0.299997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F3A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4244_14014",
    x1: 10.6763,
    y1: 7.77461,
    x2: 11.7933,
    y2: -1.39794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#776783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4244_14014",
    x1: 13.7468,
    y1: 11.33,
    x2: 13.7468,
    y2: -0.906404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#403D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#776783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4244_14014",
    x1: 14.1615,
    y1: 24.1154,
    x2: 13.9381,
    y2: 27.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4244_14014",
    x1: 13.638,
    y1: 12.6067,
    x2: 13.3189,
    y2: 19.1493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A376D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#9E4074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A95885"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#BB80A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#D3B6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E5ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4244_14014",
    x1: 14.7678,
    y1: 10.698,
    x2: 21.1254,
    y2: 10.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E0D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DACFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8CCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4244_14014",
    x1: 6.73828,
    y1: 10.3279,
    x2: 11.1426,
    y2: 10.3279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E0D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#DACFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8CCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4244_14014",
    x1: 10.6384,
    y1: 32.1007,
    x2: 10.7022,
    y2: 21.5111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#008DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFAB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4244_14014",
    x1: 5.8061,
    y1: 14.0109,
    x2: 13.702,
    y2: 7.04051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#008DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFAB2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyCombo);
export default __webpack_public_path__ + "static/media/daily_combo.006beaea651efd7860db2f7c0dcacaac.svg";
export { ForwardRef as ReactComponent };